import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  CenterAdditionalServiceDeleteUrl,
  CenterPricingDeleteUrl,
  MULTI_PURPOSE_CENTRE_ADDITIONAL_DELETE_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_ADD_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_DELETE_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_DETAIL_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_LIST_ACTION_TYPE,
  MULTI_PURPOSE_CENTRE_PRICING_DELETE_ACTION_TYPE,
  MultiPurposeCentreAddUrl,
  MultiPurposeCentreDeleteUrl,
  MultiPurposeCentreDetailUrl,
  MultiPurposeCentreListUrl,
  headers,
} from "../../utils/constants";

export const multi_purpose_centre_list_action =
  (Code, Name, CityName, StateName, CountryName, Status) =>
    async (dispatch) => {
      try {
        const mapdata = {
          userId:
            sessionStorage.getItem("userId") == "" ||
              sessionStorage.getItem("userId") == null
              ? ""
              : sessionStorage.getItem("userId"),
          Code: Code.toString().trim(),
          Name: Name.toString().trim(),
          CityName: CityName.toString().trim(),
          StateName: StateName.toString().trim(),
          CountryName: CountryName.toString().trim(),
          Status: Status == 1 ? 1 : Status == 0 ? 0 : null,
        };
        const params = {
          userId: mapdata.userId === "" ? null : mapdata.userId,
          Code: mapdata.Code === "" ? null : mapdata.Code,
          Name: mapdata.Name === "" ? null : mapdata.Name,
          CityName: mapdata.CityName === "" ? null : mapdata.CityName,
          StateName: mapdata.StateName === "" ? null : mapdata.StateName,
          CountryName: mapdata.CountryName === "" ? null : mapdata.CountryName,
          Status: mapdata.Status,
        };
        console.log("MultiPurposeCentre mapdata...", mapdata);
        const res = await axiosGet(MultiPurposeCentreListUrl, params, headers);
        console.log("MultiPurposeCentre", res);
        dispatch({
          type: MULTI_PURPOSE_CENTRE_LIST_ACTION_TYPE,
          payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const multi_purpose_centre_detail_action =
  (CenterID) => async (dispatch) => {
    try {
      const params = {
        userId:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        CenterID: CenterID ? CenterID.toString().trim() : "",
      };
      console.log("MultiPurposeCentre detail mapdata...", params);
      const res = await axiosGet(MultiPurposeCentreDetailUrl, params, headers);
      console.log("detailsMultiPurposeCentre", res);
      dispatch({
        type: MULTI_PURPOSE_CENTRE_DETAIL_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const multi_purpose_centre_add_action =
  (
    CenterID,
    Code,
    Name,
    AddressLine1,
    AddressLine2,
    CityID,
    StateID,
    CountryID,
    Pincode,
    URL,
    MaxPAX,
    Description, SecurityDepositPricingModel,
    AdditionalHourInr,
    AdditionalHourUsd,
    OvernightChargesInr,
    OvernightChargesUsd,
    TypeOfEventList,
    centerPhotoList,
    priceList, SDList,
    sittingList,
    inclusiveList,
    externalList
    , inhouseList, inhouseSubList, consumableList, securityChecklist, StatusID
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          userId:
            sessionStorage.getItem("userId") == "" ||
              sessionStorage.getItem("userId") == null
              ? ""
              : sessionStorage.getItem("userId"),
          CenterID: CenterID !== "" ? CenterID : null,
          Code: Code.toString().trim(),
          Name: Name.toString().trim(),
          AddressLine1: AddressLine1.toString().trim(),
          AddressLine2: AddressLine2.toString().trim(),
          CityID: CityID !== "" ? CityID : null,
          StateID: parseInt(StateID),
          CountryID: parseInt(CountryID),
          Pincode: Pincode !== "" ? Pincode : null,
          URL: URL.toString().trim(),
          MaxPAX: parseInt(MaxPAX),
          Description: Description.toString().trim(),
          SecurityDepositPricingModel: SecurityDepositPricingModel ? SecurityDepositPricingModel : "",
          AdditionalHourInr: AdditionalHourInr ? AdditionalHourInr : 0,
          AdditionalHourUsd: AdditionalHourUsd ? AdditionalHourUsd : 0,
          OvernightChargesInr: OvernightChargesInr ? OvernightChargesInr : 0,
          OvernightChargesUsd: OvernightChargesUsd ? OvernightChargesUsd : 0,
          TypeOfEventList: TypeOfEventList,
          priceList: priceList, SDList: SDList,
          centerPhotoList: centerPhotoList,
          sittingList: sittingList,
          inclusiveList: inclusiveList,
          externalList: externalList,
          inhouseList: inhouseList,
          inhouseSubList: inhouseSubList, consumableList: consumableList,
          securityChecklist: securityChecklist,
          StatusID: StatusID
        };
        console.log("MultiPurposeCentre add mapdata...", mapdata);

        const res = await axiosPost(MultiPurposeCentreAddUrl, mapdata, headers);
        dispatch({
          type: MULTI_PURPOSE_CENTRE_ADD_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const multi_purpose_centre_delete_action =
  (userId, CenterID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        CenterID: CenterID ? CenterID.toString().trim() : "",
      };

      const res = await axiosGet(MultiPurposeCentreDeleteUrl, mapdata, headers);
      dispatch({
        type: MULTI_PURPOSE_CENTRE_DELETE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
